<template>
  <div class="abilityss">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Abilityss'
}
</script>

<style scoped lang='less'>
</style>




// WEBPACK FOOTER //
// src/components/cashback/Cashback.vue